angular
    .module("skillBuilderSaaS")
    .factory("authInterceptorService", ["$injector", "$q", "$location", "$localStorage", "$sessionStorage", "$rootScope", "$window", AuthInterceptorService]);
function AuthInterceptorService($injector, $q, $location, $localStorage, $sessionStorage, $rootScope, $window) {
    var authInterceptorServiceFactory = {};
    var _request = function (config) {
        var authService = $injector.get('authService');
        config.headers = config.headers || {};
        if (config.url.indexOf(".well-known") !== -1)
            return config;
        if (!config.noAuth) {
            config.headers["CurrentLocalizationId"] = $localStorage.currentLocalizationId;
            if ($localStorage.tenantSettings && $localStorage.tenantSettings.defaultLocalization)
                config.headers["DefaultLocalizationId"] = $localStorage.tenantSettings.defaultLocalization.id;
            if (!config.headers.Authorization && authService.authentication.token)
                config.headers.Authorization = "Bearer " + authService.authentication.token;
        }
        return config;
    };
    var _response = function (response) {
        var test = response.config.url;
        if (test.substring(0, 4) === "/api" && (test.substring(0, 13) !== "/api/takeExam" && test.substring(0, 10) !== "/api/audit")) {
            var isBot = /bot|googlebot|crawler|spider|robot|crawling/i.test($window.navigator.userAgent);
            if (!isBot) {
                var clientVersion = $sessionStorage.version;
                var sbVersion = response.headers("SB-Version");
                var sbStatus = response.headers("SB-Status");
                //if major.year.day.rev is different, show modal
                if (clientVersion) {
                    if (sbVersion) {
                        //clientVersion = clientVersion.substr(0, clientVersion.lastIndexOf("."));
                        //sbVersion = sbVersion.substr(0, sbVersion.lastIndexOf("."));
                        if (clientVersion != sbVersion)
                            $rootScope.$broadcast("getNewVersion");
                    }
                }
                else {
                    $sessionStorage.version = sbVersion;
                }
                if (sbStatus === "NotFound")
                    window.location.href = "tenantNotFound.html";
                else if (sbStatus === "Maintenance")
                    window.location.href = "maintenance.html";
            }
        }
        return response;
    };
    var _responseError = function (rejection) {
        if (rejection.status === 401) {
            $location.path("/sign-out");
            $location.replace();
        }
        else if (rejection.status === 403) {
            $location.path("/access-denied");
            $location.replace();
        }
        else if (rejection.status === 404) {
            $rootScope.$broadcast("NOT-FOUND");
        }
        else if (rejection.status === 409) {
            console.log("REJECTION:", rejection);
        }
        return $q.reject(rejection);
    };
    authInterceptorServiceFactory.request = _request;
    authInterceptorServiceFactory.response = _response;
    authInterceptorServiceFactory.responseError = _responseError;
    return authInterceptorServiceFactory;
}
